import { createContext, ReactNode, useContext, useMemo, useState } from 'react';
import { DashboardView } from './types';

type DashboardViewContextValue = {
    activeView: DashboardView;
    setActiveView: (view: DashboardView) => void;
};

const noop = (_view: DashboardView) => {
    // No-op fallback used until a provider supplies a real setter.
};

const DashboardViewContext = createContext<DashboardViewContextValue>({
    activeView: 'clients',
    setActiveView: noop,
});

export const DashboardViewProvider = ({ children }: { children: ReactNode }) => {
    const [activeView, setActiveView] = useState<DashboardView>('clients');
    const value = useMemo(() => ({ activeView, setActiveView }), [activeView]);
    return <DashboardViewContext.Provider value={value}>{children}</DashboardViewContext.Provider>;
};

export const useDashboardView = () => useContext(DashboardViewContext);
